import { motion } from 'framer-motion';
import Logo from "../public/Asset2-100.jpg";

const Footer = () => {
  // Footer link animation variants
  const linkVariants = {
    hover: {
      x: 5,
      color: "#3b82f6", // blue-500
      transition: { duration: 0.2 }
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 }
    }
  };

  // Social icons data
  const socialIcons = [
    {
      name: "Facebook",
      icon: (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M21.5 11.0635C21.5 5.26504 16.7984 0.563477 11 0.563477C5.20156 0.563477 0.5 5.26504 0.5 11.0635C0.5 16.3041 4.33906 20.648 9.35938 21.4364V14.0996H6.69266V11.0635H9.35938V8.75019C9.35938 6.1191 10.9273 4.66457 13.3255 4.66457C14.4744 4.66457 15.6763 4.86988 15.6763 4.86988V7.4541H14.3516C13.048 7.4541 12.6402 8.26316 12.6402 9.09473V11.0635H15.552L15.087 14.0996H12.6406V21.4374C17.6609 20.6494 21.5 16.3055 21.5 11.0635Z" fill="white"/>
        </svg>
      ),
      url: "#"
    },
    {
      name: "Twitter",
      icon: (
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.25 2.13282C22.406 2.49955 21.513 2.74116 20.5992 2.85001C21.5595 2.28769 22.2817 1.39434 22.6303 0.337508C21.7224 0.86841 20.7307 1.24092 19.6978 1.43907C19.2629 0.983225 18.7397 0.620588 18.1603 0.373201C17.5808 0.125814 16.9571 -0.00115656 16.327 7.93801e-06C13.7761 7.93801e-06 11.7117 2.03438 11.7117 4.5422C11.7099 4.89102 11.7499 5.23881 11.8308 5.57813C10.0016 5.49238 8.2104 5.02575 6.57187 4.2081C4.93333 3.39044 3.48351 2.23977 2.31516 0.829695C1.90527 1.52069 1.6885 2.30909 1.6875 3.11251C1.6875 4.68751 2.50922 6.0797 3.75 6.89532C3.01487 6.87787 2.29481 6.68331 1.65094 6.32813V6.38438C1.65094 8.58751 3.24469 10.4203 5.35406 10.8375C4.9574 10.9432 4.54864 10.9968 4.13812 10.9969C3.84683 10.9974 3.5562 10.9691 3.27047 10.9125C3.85687 12.7172 5.56359 14.0297 7.58531 14.0672C5.94252 15.3333 3.9256 16.0175 1.85156 16.0125C1.48341 16.012 1.11561 15.99 0.75 15.9469C2.85993 17.2942 5.31255 18.0068 7.81594 18C16.3172 18 20.9616 11.0766 20.9616 5.07188C20.9616 4.87501 20.9564 4.67813 20.947 4.48595C21.8485 3.84472 22.6283 3.04787 23.25 2.13282Z" fill="white"/>
        </svg>
      ),
      url: "#"
    },
    {
      name: "Instagram",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2.1626C15.204 2.1626 15.5844 2.175 16.8504 2.2332C18.0492 2.2884 18.6528 2.4828 19.0524 2.6436C19.5924 2.8596 19.9788 3.1284 20.3784 3.528C20.778 3.9276 21.0468 4.314 21.2628 4.854C21.4236 5.2536 21.618 5.8572 21.6732 7.056C21.7314 8.322 21.7438 8.7024 21.7438 11.9064C21.7438 15.1104 21.7314 15.4908 21.6732 16.7568C21.618 17.9556 21.4236 18.5592 21.2628 18.9588C21.0468 19.4988 20.778 19.8852 20.3784 20.2848C19.9788 20.6844 19.5924 20.9532 19.0524 21.1692C18.6528 21.33 18.0492 21.5244 16.8504 21.5796C15.5844 21.6378 15.204 21.6502 12 21.6502C8.796 21.6502 8.4156 21.6378 7.1496 21.5796C5.9508 21.5244 5.3472 21.33 4.9476 21.1692C4.4076 20.9532 4.0212 20.6844 3.6216 20.2848C3.222 19.8852 2.9532 19.4988 2.7372 18.9588C2.5764 18.5592 2.382 17.9556 2.3268 16.7568C2.2686 15.4908 2.2562 15.1104 2.2562 11.9064C2.2562 8.7024 2.2686 8.322 2.3268 7.056C2.382 5.8572 2.5764 5.2536 2.7372 4.854C2.9532 4.314 3.222 3.9276 3.6216 3.528C4.0212 3.1284 4.4076 2.8596 4.9476 2.6436C5.3472 2.4828 5.9508 2.2884 7.1496 2.2332C8.4156 2.175 8.796 2.1626 12 2.1626ZM12 0C8.7324 0 8.322 0.0126 7.0392 0.0708C5.7684 0.1284 4.8204 0.33 4.0032 0.6252C3.1504 0.9324 2.4264 1.3572 1.7028 2.0808C0.9792 2.8044 0.5544 3.528 0.2472 4.3808C-0.048 5.198 -0.2496 6.1464 -0.3072 7.416C-0.3678 8.7 -0.378 9.1104 -0.378 12.378C-0.378 15.6456 -0.3678 16.056 0.3072 17.34C0.2496 18.6096 0.048 19.5582 -0.2472 20.3754C-0.5544 21.228 -0.9792 21.9522 -1.7028 22.6758C-2.4264 23.3994 -3.1504 23.8242 -4.0032 24.1314C-4.8204 24.4266 -5.7684 24.6282 -7.0392 24.6858C-8.322 24.7458 -8.7324 24.756 -12 24.756C-15.2676 24.756 -15.678 24.7458 -16.9608 24.6858C-18.2316 24.6282 -19.1796 24.4266 -19.9968 24.1314C-20.8496 23.8242 -21.5736 23.3994 -22.2972 22.6758C-23.0208 21.9522 -23.4456 21.228 -23.7528 20.3754C-24.048 19.5582 -24.2496 18.6096 -24.3072 17.34C-24.3678 16.056 -24.378 15.6456 -24.378 12.378C-24.378 9.1104 -24.3678 8.7 -24.3072 7.416C-24.2496 6.1464 -24.048 5.198 -23.7528 4.3808C-23.4456 3.528 -23.0208 2.8044 -22.2972 2.0808C-21.5736 1.3572 -20.8496 0.9324 -19.9968 0.6252C-19.1796 0.33 -18.2316 0.1284 -16.9608 0.0708C-15.678 0.0126 -15.2676 0 -12 0Z" fill="white"/>
          <path d="M12 5.8374C8.5968 5.8374 5.8374 8.5968 5.8374 12C5.8374 15.4032 8.5968 18.1626 12 18.1626C15.4032 18.1626 18.1626 15.4032 18.1626 12C18.1626 8.5968 15.4032 5.8374 12 5.8374ZM12 15.8376C9.8052 15.8376 8.0244 14.0568 8.0244 11.862C8.0244 9.6672 9.8052 7.8864 12 7.8864C14.1948 7.8864 15.9756 9.6672 15.9756 11.862C15.9756 14.0568 14.1948 15.8376 12 15.8376ZM19.9236 5.5908C19.9236 6.3972 19.2588 7.062 18.4524 7.062C17.646 7.062 16.9812 6.3972 16.9812 5.5908C16.9812 4.7844 17.646 4.1196 18.4524 4.1196C19.2588 4.1196 19.9236 4.7844 19.9236 5.5908Z" fill="white"/>
        </svg>
      ),
      url: "#"
    }
  ];

  // Footer column data
  const footerColumns = [
    {
      title: "Plan Events",
      links: [
        "Create Event",
        "Pricing Plan",
        "Sell Ticket",
        "QR codes for Event Check-In"
      ]
    },
    {
      title: "Find Events",
      links: [
        "Lagos Event",
        "Kaduna Event",
        "Owerri Event"
      ]
    },
    {
      title: "Connect with us",
      links: [
        "Our Channel",
        // Social icons will be added below this
      ]
    }
  ];

  return (
    <footer className="bg-[#121513] text-white pt-8 md:pt-12 pb-6 md:pb-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Logo and columns container */}
        <div className="flex flex-col lg:flex-row justify-between gap-8">
          {/* Logo section */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="mb-6 lg:mb-0"
          >
            <img src={Logo} alt="Eventli Logo" className="h-8 w-auto mb-4" /> 
            <p className="text-gray-400 max-w-xs text-sm md:text-base">
              Create, discover, and attend amazing events with Eventli.
            </p>
          </motion.div>

          {/* Footer columns */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
            {footerColumns.map((column, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="text-lg sm:text-xl md:text-[24px] font-medium mb-4 text-white">{column.title}</h3>
                <ul className="space-y-3">
                  {column.links.map((link, linkIndex) => (
                    <motion.li
                      key={linkIndex}
                      variants={linkVariants}
                      whileHover="hover"
                      whileTap="tap"
                    >
                      <a 
                        href="/" 
                        className="block text-gray-400 text-sm md:text-base font-medium hover:text-blue-500 transition-colors"
                      >
                        {link}
                      </a>
                    </motion.li>
                  ))}
                  {/* Add social icons to the "Connect with us" column */}
                  {column.title === "Connect with us" && (
                    <div className="flex gap-4 mt-4">
                      {socialIcons.map((social, index) => (
                        <motion.a
                          key={index}
                          href={social.url}
                          aria-label={social.name}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="text-gray-400 hover:text-white transition-colors"
                        >
                          {social.icon}
                        </motion.a>
                      ))}
                    </div>
                  )}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Copyright section */}
        <div className="text-center text-gray-400 text-sm border-t border-gray-800 mt-8 pt-6">
          © {new Date().getFullYear()} Eventli. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;